import { withFormik } from 'formik';
import isEmail from 'isemail';
import PropTypes from 'prop-types';
import React from 'react';

import BasicCheckbox from '@legacy-components/forms/fields/BasicCheckbox';

import BasicInput from './fields/BasicInput';

class InnerForm extends React.Component {
  static propTypes = {
    handleSubmit: PropTypes.func,
    isSubmitting: PropTypes.bool,
    forgotPassword: PropTypes.func,
    isLoggingIn: PropTypes.bool,
    resetForm: PropTypes.func,
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.isLoggingIn && !nextProps.isLoggingIn) {
      const email = this.props.values['email'];
      const remember = this.props.values['remember'];
      this.props.resetForm();
      this.props.setFieldValue('email', email);
      this.props.setFieldValue('remember', remember);
    }
  }

  render() {
    const { handleSubmit, isSubmitting, forgotPassword } = this.props;
    return (
      <form className="m-login__form m-form" onSubmit={handleSubmit} autoComplete="off">
        <BasicInput {...this.props} name="email" type="text" placeholder="Email" autocomplete="username" />

        <BasicInput
          {...this.props}
          name="password"
          type="password"
          placeholder="Password"
          autocomplete="current-password"
          className="m-login__form-input--last"
        />

        <div className="row m-login__form-sub">
          <div className="col m--align-left">
            <BasicCheckbox {...this.props} name="remember" label="Remember me" />
          </div>
          <div className="col m--align-right">
            <a href="#" className="m-link" onClick={forgotPassword}>
              Forget Password?
            </a>
          </div>
        </div>

        <div className="m-login__form-action">
          <button
            id="m_login_signin_submit"
            className="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air"
            disabled={isSubmitting}
          >
            Sign In
          </button>
        </div>
      </form>
    );
  }
}

const LoginForm = withFormik({
  mapPropsToValues: (props) => ({
    email: '',
    password: '',
    remember: true,
  }),
  validate: (values, props) => {
    let errors = {};
    if (!values.email) {
      errors.email = 'Required';
    } else if (!isEmail.validate(values.email)) {
      errors.email = 'Invalid email address';
    }
    return errors;
  },
  handleSubmit: (values, { props }) => {
    props.onSubmit(values);
  },
})(InnerForm);

export default LoginForm;
